import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const EmptyState = ({ onAddOffer }) => {
  return (
    <div className="bg-card rounded-lg border border-border p-8 md:p-12 text-center">
      <div className="max-w-md mx-auto">
        <div className="w-20 h-20 mx-auto mb-6 rounded-full bg-primary/10 flex items-center justify-center">
          <Icon name="FileText" size={40} className="text-primary" />
        </div>

        <h3 className="text-xl md:text-2xl font-semibold text-foreground mb-3">
          No Offers Yet
        </h3>

        <p className="text-sm md:text-base text-muted-foreground mb-6">
          Start by adding your first offer for this property. You can add multiple offers and compare them side-by-side to help your seller make an informed decision.
        </p>

        <Button
          variant="default"
          size="lg"
          onClick={onAddOffer}
          iconName="Plus"
          iconPosition="left"
        >
          Add First Offer
        </Button>

        <div className="mt-8 pt-8 border-t border-border">
          <h4 className="text-sm font-semibold text-foreground mb-3">What you can do:</h4>
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 text-left">
            <div className="flex items-start gap-3">
              <Icon name="Check" size={16} className="text-success flex-shrink-0 mt-1" />
              <div>
                <p className="text-sm font-medium text-foreground">Add Multiple Offers</p>
                <p className="text-xs text-muted-foreground">Enter all offer details and terms</p>
              </div>
            </div>
            <div className="flex items-start gap-3">
              <Icon name="Check" size={16} className="text-success flex-shrink-0 mt-1" />
              <div>
                <p className="text-sm font-medium text-foreground">Compare Side-by-Side</p>
                <p className="text-xs text-muted-foreground">View all offers in one place</p>
              </div>
            </div>
            <div className="flex items-start gap-3">
              <Icon name="Check" size={16} className="text-success flex-shrink-0 mt-1" />
              <div>
                <p className="text-sm font-medium text-foreground">Add Internal Notes</p>
                <p className="text-xs text-muted-foreground">Keep track of important details</p>
              </div>
            </div>
            <div className="flex items-start gap-3">
              <Icon name="Check" size={16} className="text-success flex-shrink-0 mt-1" />
              <div>
                <p className="text-sm font-medium text-foreground">Generate Reports</p>
                <p className="text-xs text-muted-foreground">Create professional PDFs</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EmptyState;